"use client";

import OfficeGallery from "@/components/ourOffice/Gallery";
import OfficeHeroBanner from "@/components/ourOffice/Hero";
import OfficeContent from "@/components/ourOffice/OfficeContent";
import React from "react";

const OurOffice: React.FC = () => {
  return (
    <>
      <div>
        <OfficeHeroBanner />
        <OfficeContent />
        <OfficeGallery />
      </div>
    </>
  );
};

export default OurOffice;